<div [ngStyle]="{
    'display': 'inline-block',
    'min-width': '300px',
    'width': '100%',
    'overflow-x':'hidden'
  }">
  <div nz-row [nzGutter]="[16,16]" class="pt-lg">
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">
      <g2-card [title]="'Total User'" total="{{userTotal}}" contentHeight="44px" [action]="action1">
        <ng-template #action1>
          <i nz-tooltip [nzTooltipTitle]="'Total User'" nz-icon nzType="info-circle"></i>
        </ng-template>
        <ng-template ngFor let-item [ngForOf]="genderData" let-i="index">
          <trend style="display: block; margin-top: 2px">
            {{ item.x }}
            <span class="pl-sm">{{ item.y }}</span>
          </trend>
        </ng-template>
      </g2-card>
    </div>
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">


      <g2-card [title]="'Total Post'" [total]="postData?.overview?.data?.total" contentHeight="44px" [action]="action1">
        <ng-template #action1>
          <i nz-tooltip [nzTooltipTitle]="'Total Post'" nz-icon nzType="info-circle"></i>
        </ng-template>

        <trend style="display: block; margin-top: 2px">
          Business Post
          <span class="pl-sm">{{ postData?.overview?.data?.bizPosts }}</span>
        </trend>

        <trend style="display: block; margin-top: 2px">
          User Post
          <span class="pl-sm">{{ postData?.overview?.data?.userPosts }}</span>
        </trend>

      </g2-card>

    </div>
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">
      <g2-card *ngIf="postData" [title]="'Total User Post'" [total]="postData?.userpost?.data?.total"
        contentHeight="44px" [action]="action1">
        <ng-template #action1>
          <i nz-tooltip [nzTooltipTitle]="'Total User Post'" nz-icon nzType="info-circle"></i>
        </ng-template>
        <trend *ngFor="let item of postData?.userpost?.data?.userPosts; let i = index"
          style="display: block; margin-top: 2px">
          {{ item?.status |capitalLetter}}
          <span class="pl-sm">{{ item?.count }}</span>
        </trend>
      </g2-card>
    </div>
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">
      <g2-card [title]="'Total Product'" [total]="productTotal" contentHeight="44px" [action]="actionProduct">
        <ng-template #actionProduct>
          <i nz-tooltip [nzTooltipTitle]="'Total Product'" nz-icon nzType="info-circle"></i>
        </ng-template>
        <trend *ngFor="let item of productStatusCounts; let i = index" style="display: block; margin-top: 2px">
          {{ item?.status |capitalLetter}}
          <span class="pl-sm">{{ item?.count }}</span>
        </trend>
      </g2-card>
    </div>

  </div>
  <div nz-row [nzGutter]="[16,16]">
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12">
      <nz-card [nzSize]="'small'">
        <h3>User Gender</h3>
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isChartReady" [series]="apexPieChartOptions.series" [chart]="apexPieChartOptions.chart"
            [labels]="apexPieChartOptions.labels" [responsive]="apexPieChartOptions.responsive"
            [legend]="apexPieChartOptions.legend" [plotOptions]="apexPieChartOptions.plotOptions"
            [tooltip]="apexPieChartOptions.tooltip" (dataPointSelection)="onPieChartSelection($event)">
          </apx-chart>
          <div *ngIf="!isChartReady" class="chart-loading">
            <p>Loading chart data...</p>
          </div>
        </div>
      </nz-card>

    </div>



    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12">
      <nz-card [nzSize]="'small'">
        <h3>Posts</h3>
        <apx-chart *ngIf="isChartReady" [series]="apexPieChartPostOptions.series"
          [chart]="apexPieChartPostOptions.chart" [labels]="apexPieChartPostOptions.labels"
          [responsive]="apexPieChartPostOptions.responsive" [legend]="apexPieChartPostOptions.legend"
          [plotOptions]="apexPieChartPostOptions.plotOptions" [tooltip]="apexPieChartPostOptions.tooltip"
          (dataPointSelection)="onPieChartSelection($event)">
        </apx-chart>
        <div *ngIf="!isChartReady" class="chart-loading">
          <p>Loading chart data...</p>
        </div>
      </nz-card>

    </div>
  </div>

  <div nz-row [nzGutter]="[16,16]">
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
      <nz-card [nzSize]="'small'">
        <h3>User Location</h3>
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isUserLocationChartReady" [series]="apexBarChartOptions.series"
            [chart]="apexBarChartOptions.chart" [xaxis]="apexBarChartOptions.xaxis"
            [legend]="apexBarChartOptions.legend" [responsive]="apexBarChartOptions.responsive">
          </apx-chart>
          <div *ngIf="!isUserLocationChartReady" class="chart-loading">
            <p>Loading chart data...</p>
          </div>
        </div>
      </nz-card>

    </div>
    <!-- <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12">
      <nz-card [nzSize]="'small'">
        <h3>Line Chart</h3>
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isChartReady"  [series]="apexLineChartOptions.series" [chart]="apexLineChartOptions.chart"
            [xaxis]="apexLineChartOptions.xaxis" [legend]="apexLineChartOptions.legend" [responsive]="apexLineChartOptions.responsive">
          </apx-chart>
           <div *ngIf="!isChartReady" class="chart-loading">
          <p>Loading chart data...</p>
        </div>
        </div>
      </nz-card>

    </div> -->
  </div>
  <!-- age -->
  <div nz-row [nzGutter]="[16,16]">
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
      <nz-card [nzSize]="'small'">
        <h3>User Age</h3>
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isUserAgeChartReady" [series]="userAgebarChartOptions.series"
            [chart]="userAgebarChartOptions.chart" [xaxis]="userAgebarChartOptions.xaxis"
            [legend]="userAgebarChartOptions.legend" [responsive]="userAgebarChartOptions.responsive">
          </apx-chart>
          <div *ngIf="!isUserAgeChartReady" class="chart-loading">
            <p>Loading chart data...</p>
          </div>
        </div>
      </nz-card>
    </div>
  </div>

  <!-- <div nz-row [nzGutter]="[16,16]">
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
      <nz-card [nzSize]="'small'">
        <h3>User Registrationn</h3>
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isUserLocationChartReady" [series]="userRegBarChartOptions.series"
            [chart]="userRegBarChartOptions.chart" [xaxis]="userRegBarChartOptions.xaxis"
            [legend]="userRegBarChartOptions.legend" [responsive]="userRegBarChartOptions.responsive">
          </apx-chart>
          <div *ngIf="!isUserLocationChartReady" class="chart-loading">
            <p>Loading chart data...</p>
          </div>
        </div>
      </nz-card>

    </div>
  </div> -->

  <div nz-row [nzGutter]="[16,16]">
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
      <nz-card [nzSize]="'small'" [nzTitle]="titleTemplate">
        <!-- Card body -->
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isUserLocationChartReady" [series]="userRegBarChartOptions.series"
            [chart]="userRegBarChartOptions.chart" [xaxis]="userRegBarChartOptions.xaxis"
            [legend]="userRegBarChartOptions.legend" [responsive]="userRegBarChartOptions.responsive">
          </apx-chart>

          <div *ngIf="!isUserLocationChartReady" class="chart-loading">
            <p>Loading chart data...</p>
          </div>
        </div>
      </nz-card>

      <!-- Title template -->
      <ng-template #titleTemplate>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <h3 style="margin: 0;">User Registration</h3>
          <nz-select [(ngModel)]="selectedValue" style="width: 150px;" (ngModelChange)="onFilterChange($event)">
            <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label">
            </nz-option>
          </nz-select>
        </div>
      </ng-template>
    </div>
  </div>

  <!--Business User -->

  <div nz-row [nzGutter]="[16,16]">
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
      <nz-card [nzSize]="'small'" [nzTitle]="bizTitleTemplate">
        <!-- Card body -->
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isBusinessRegistrationChartReady" [series]="bizRegBarChartOptions.series"
            [chart]="bizRegBarChartOptions.chart" [xaxis]="bizRegBarChartOptions.xaxis"
            [legend]="bizRegBarChartOptions.legend" [responsive]="bizRegBarChartOptions.responsive">
          </apx-chart>

          <div *ngIf="!isBusinessRegistrationChartReady" class="chart-loading">
            <p>Loading chart data...</p>
          </div>
        </div>
      </nz-card>

      <!-- register template -->
      <ng-template #bizTitleTemplate>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <h3 style="margin: 0;">Business User</h3>
          <nz-select [(ngModel)]="selectedValue" style="width: 150px;" (ngModelChange)="onBizFilterChange($event)">
            <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label">
            </nz-option>
          </nz-select>
        </div>
      </ng-template>

    </div>
  </div>

  <!--Post Search History -->
  <div nz-row [nzGutter]="[16,16]">
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
      <nz-card [nzSize]="'small'" [nzTitle]="postSearchTemplate">
        <!-- Card body -->
        <div class="chart-responsive-container">
          <apx-chart *ngIf="isPostSearchHistoryChartReady" [series]="postSearchChartOptions.series"
            [chart]="postSearchChartOptions.chart" [xaxis]="postSearchChartOptions.xaxis"
            [legend]="postSearchChartOptions.legend" [responsive]="postSearchChartOptions.responsive">
          </apx-chart>

          <div *ngIf="!isPostSearchHistoryChartReady" class="chart-loading">
            <p>Loading chart data...</p>
          </div>
        </div>
      </nz-card>
      <!-- register template -->
      <ng-template #postSearchTemplate>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <h3 style="margin: 0;">{{ postSearchTitle }}</h3>
          <nz-select [(ngModel)]="postSearchSelectedValue" style="width: 150px;"
            (ngModelChange)="onPostSearchHistoryFilterChange($event)">
            <nz-option *ngFor="let option of postSearchoptions" [nzValue]="option.value" [nzLabel]="option.label">
            </nz-option>
          </nz-select>
        </div>
      </ng-template>
    </div>
  </div>
  <!-- end post search history -->

  <!-- most liked posts -->
  <nz-card nzBordered [nzTitle]="'Most Liked Posts'" class="top-liked-posts-card">
    <div class="top-liked-posts-container">
      <div *ngFor="let post of topLikedPosts" class="top-liked-post">
        <nz-card nzHoverable class="post-card">

          <!-- Card image OR placeholder -->
          <ng-container *ngIf="post.image?.length > 0; else noImage">
            <img nz-cover [src]="post.image[0]?.url || post.image[0]" class="post-image" />
          </ng-container>
          <ng-template #noImage>
            <div class="placeholder-container">
              <i nz-icon nzType="picture" nzTheme="outline"></i>
              <span>No Image</span>
            </div>
          </ng-template>

          <nz-card-meta [nzTitle]="post.product_name || post.title_name || 'Untitled Post'"
            [nzDescription]="getPostPreview(post.content)">
          </nz-card-meta>

          <div class="post-footer">
            <span>
              <i nz-icon nzType="like" nzTheme="outline"></i> {{ post.post_like_count || 0 }}
            </span>
            <span>
            </span>
            <span>
              <i nz-icon nzType="calendar" nzTheme="outline"></i> {{ post.published_date | date:'shortDate' }}
            </span>
          </div>

        </nz-card>
      </div>
    </div>
  </nz-card>

  <!-- most liked Product -->
  <nz-card nzBordered [nzTitle]="'Most Liked Products'" class="top-liked-posts-card">
    <div class="top-liked-posts-container">
      <div *ngFor="let post of topLikedProducts" class="top-liked-post">
        <nz-card nzHoverable class="post-card">

          <ng-container *ngIf="post.image?.length > 0; else noImage">
            <img nz-cover [src]="post.image[0]?.url || post.image[0]" class="post-image" />
          </ng-container>
          <ng-template #noImage>
            <div class="placeholder-container">
              <i nz-icon nzType="picture" nzTheme="outline"></i>
              <span>No Image</span>
            </div>
          </ng-template>

          <nz-card-meta [nzTitle]="post.product_name || post.title_name || 'Untitled Post'"
            [nzDescription]="getPostPreview(post.content)">
          </nz-card-meta>

          <div class="post-footer">
            <span>
              <i nz-icon nzType="like" nzTheme="outline"></i> {{ post.total_likes || 0 }}

            </span>
            <span>
            </span>
            <span>
              <i nz-icon nzType="calendar" nzTheme="outline"></i> {{ post.published_date | date:'shortDate' }}
            </span>
          </div>

        </nz-card>
      </div>
    </div>
  </nz-card>

  <div nz-row>
    <div nz-col nzSpan="24">
      <div class="header-row">
        <nz-select [(ngModel)]="selectedYear" (ngModelChange)="onYearChange($event)" style="width: 200px;">
          <nz-option *ngFor="let year of years" [nzValue]="year" [nzLabel]="year"></nz-option>
        </nz-select>
      </div>
    </div>
  </div>

  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-table #basicTable [nzData]="listOfData" [nzLoading]="isLoading" [nzShowPagination]="true"
        [nzFrontPagination]="false" nzServerRender nzOuterBordered [nzPageSize]="_pageSize" [nzPageIndex]="_pageIndex"
        [nzTotal]="total" (nzPageIndexChange)="onPageIndexChange($event)" [nzShowTotal]="totalTemplate"
        [nzScroll]="{ x:'1200px',y: tableHeight }">
        <thead>
          <tr>

            <th nzWidth="150px">Name</th>

            <th nzWidth="150px">Last Price</th>

            <th nzWidth="150px">Group</th>

            <th nzWidth="150px">Main Category</th>

            <th nzWidth="150px">Category</th>

            <th nzWidth="150px">Item-Category</th>

            <th nzRight="100px" nzWidth="200px">Chart Data</th>

            <th nzRight="0" nzWidth="100px">Action</th>

          </tr>
          <tr>

            <th *ngFor="let column of [
            
            { id: 'item_name', placeholder: 'Search Name' },
            
            { id: 'last_price', placeholder: 'Search Price' },
            
            { id: 'group_name', placeholder: 'Search Group' },
            
            { id: 'maincategory_name', placeholder: 'Search Main Category' },
            
            { id: 'category_name', placeholder: 'Search Category' },
            
            { id: 'subcategory_name', placeholder: 'Search Item-Category' }
            
            ]">

              <input nz-input [(ngModel)]="searchMap[column.id]" (input)="onSearchInput()"
                [placeholder]="column.placeholder">

            </th>

            <th nzRight="100px" nzWidth="200px">
              <nz-select [(ngModel)]="searchMap['period']" (ngModelChange)="onPeriodChange()" style="width: 180px;">
                <nz-option *ngFor="let period of periods" [nzValue]="period" [nzLabel]="period"></nz-option>
              </nz-select>
            </th>

            <th nzRight="0px" nzWidth="150px"><!-- Empty for action column --></th>

          </tr>
        </thead>
        <tbody>
          @for (data of basicTable.data; track data) {
          <tr>
            <td>{{ data.item_name }}</td>
            <td>{{ data.newPrice }}</td>
            <td>{{ data.group_name }}</td>
            <td>{{ data.maincategory_name }}</td>
            <td>{{ data.category_name }}</td>
            <td>{{ data.subcategory_name }}</td>
            <td nzRight="100px" nzWidth="200px"><g2-mini-area line color="#cceafe" height="45" [data]="data.prices" />
            </td>
            <td nzRight="0px" nzWidth="150px">
              <a (click)="detail(data.item_id)">Details</a>
            </td>
          </tr>
          }
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-range="range" let-total>
        Showing {{ range[0] }} - {{ range[1] }} of {{ total }} items
      </ng-template>
    </div>
  </div>
</div>